import {DateRange} from '@/dateUtils/DateRange'
import {computed, Ref} from 'vue'
import {DateRangeMatrix} from '@/dateUtils/v2/DateRangeMatrix'
import {ensureUTC} from '@/dateUtils/v2/DateRange.util'

export const useYearMatrix = (range: Ref<DateRange>, isDisabled?: (range: DateRange) => boolean) => {
    ensureUTC(range)

    const isYearSelected = (year: number) => {
        return range.value.start.getFullYear() === year &&
            range.value.end.getFullYear() === year
    }

    const getYearRange = (year: number) => ({
        start: new Date(Date.UTC(year, 0, 1)),
        end: new Date(Date.UTC(year, 11, 31))
    })

    const selectYear = (year: number) => {
        range.value = getYearRange(year)
    }

    const selectedYear = computed(() =>
        range.value.start.getFullYear() === range.value.end.getFullYear() ? range.value.start.getFullYear() : undefined
    )

    const years = computed<DateRangeMatrix[]>(() => {
        const currentYear = selectedYear.value ?? new Date().getFullYear()

        return [currentYear - 2, currentYear - 1, currentYear].map(year => {
            const range = getYearRange(year)
            return {
                value: year,
                label: year.toString(),
                selected: isYearSelected(year),
                disabled: !!isDisabled && isDisabled(range),
                onClick: () => selectYear(year),
                range: range
            } as DateRangeMatrix
        })
    })

    const nextYear = computed(() => (selectedYear.value ?? new Date().getFullYear()) + 1)
    const next = () => selectYear(nextYear.value)
    const nextDisabled = computed(() => !!isDisabled && isDisabled(getYearRange(nextYear.value)))
    const prevYear = computed(() => (selectedYear.value ?? new Date().getFullYear()) - 1)
    const prev = () => selectYear(prevYear.value)
    const prevDisabled = computed(() => !!isDisabled && isDisabled(getYearRange(prevYear.value)))

    return {
        range,
        selectedYear,
        years,
        isYearSelected,
        selectYear,
        next,
        nextDisabled,
        prev,
        prevDisabled
    }
}